import type {Nullable} from '../../utils/utility-types';

export const makeSrcSet = (
  getImageSrc: (scale: number) => Nullable<string>,
) => {
  return [1, 2, 3]
    .map(scale => `${getImageSrc(scale)} ${scale}x`)
    .filter(Boolean)
    .join(',');
};
